import { Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {ReactComponent as CrossIcon} from "assets/img/svg/CrossIcon.svg"
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import moment from "moment";
import { Tooltip } from "@mui/material";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import ALoader from 'views/pages/manage/common/a-loader';
import { concatenateObjectValues } from './constant';
import { processRowList } from '../constant';
const LogsDialoge=({
logsDialogeInfo,
setLogsDialogeInfo,
buId,
dropdowns={}
  })=>{

const [loader,setLoader] = useState(false)
const [rowData,setRowData] = useState([{}])
// const [endpoint,key,tabName]= logsDialogeInfo
useEffect(()=>{
buId&&getlogs()
},[])


const getlogs=async()=>{

    try{
        setLoader(true)
        const url = `${logsDialogeInfo?.endpoint}/${buId}`
        const data = await fetchAllPromisedData(url)
         const rowList= processRowList(data?.locationDetailsAudDtoList??data?.contactDetailsMasterAudList??data,dropdowns)
        setRowData(rowList)
    }
    catch(err){
       console.log(err)
    }
    finally{
        setLoader(false)
    }
}
const columns=[
    new AGridColDef("updatedOn", "Date", false)
            .setMinWidth(100)
            .editable(true)
            .setFlex(2)
            .renderCellComponent((params) => (
              params?.value ? <Tooltip title={moment(params?.value).format('DD/MM/YYYY')}>
                <div className={`ellipsis-text-container`}>{moment(params?.value).format('DD/MM/YYYY')}</div>
              </Tooltip> : <div>-</div>
            )),
            new AGridColDef("value", "Value", false)
            .setMinWidth(100)
            .editable(true)
            .setFlex(2)
            .renderCellComponent((params) => (
             <Tooltip title={`${concatenateObjectValues(params?.row)}`}>
                <div className={`ellipsis-text-container`} >{`${concatenateObjectValues(params?.row)}`}</div>
              </Tooltip>
            )),
            new AGridColDef("updatedBy", "Last updated by", false)
            .setMinWidth(100)
            .editable(true)
            .setFlex(2)
            .renderCellComponent((params) => (
              params?.value ? <Tooltip title={`${moment(params?.row?.updatedOn).format('DD-MM-YYYY')} ${moment(params?.row?.updatedOn).format('hh:mm A')},  by ${params?.value}`}>
                <div className={`ellipsis-text-container`} >{`${moment(params?.row?.updatedOn).format('DD-MM-YYYY')} ${moment(params?.row?.updatedOn).format('hh:mm A')},  by ${params?.value}`}</div>
              </Tooltip> : <div>-</div>
            )),
           
]
console.log('columns',columns,columns[0]?.headerName)
    return(
    <Dialog
        open={logsDialogeInfo}
        PaperProps={{ sx: { maxWidth: "unset", borderRadius: "12px" } }}
      >
        <div className="select-concession-popup">
          <div className="d-flex " style={{ justifyContent: "space-between" }}>
            {loader&& <ALoader/>}
            <div className="heading-4 color-dark" >{logsDialogeInfo?.tabName} </div>
            <CrossIcon onClick={()=>setLogsDialogeInfo(false)}/>

            </div>
            <div className="" style={{border:'1px solid #EEE', borderRadius:'8px'}}>
                    <ADataGrid
                      removeWrapperContainer
                      rowModesModel
                      rows={rowData || []}
                      columns={columns}
                      rowId={(row) =>JSON.stringify(row)}
                      rowHeight={50}
                      rowCount={rowData.length}
                      loading={false}
                      components={{
                        ...gridComponents,
                        NoRowsOverlay: () => (
                          <NoRowOverlay message={loader ? "Loading..." : null} />
                        ),
                      }}
                      sx={{
                        ...gridStyles,
                      }}
                      autoHeight
                      hidePagination={true}
                    />
                  </div>
            {/* <ListComponent loader={loader} rows={jodoHistoryData} /> */}
    </div>
    </Dialog>
    )
}
export default LogsDialoge;